import React from "react";
import { Box, Typography } from "@mui/material";
import useTranslation from "../../../../../hooks/useTranslation";

const TransactionError = () => {
  const { t } = useTranslation("translation", { keyPrefix: "walletHistory" });

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        m: "64px 64px 100px 64px",
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: "grey.accent2", textAlign: "center" }}
      >
        {t("This function is temporarily unavailable. Please try again later.")}
      </Typography>
    </Box>
  );
};

export default TransactionError;
